// extracted by mini-css-extract-plugin
export var component = "TimeRemaining-module--component--23b0e";
export var fadePop = "TimeRemaining-module--fade-pop--b0ef7";
export var growHeightIn = "TimeRemaining-module--grow-height-in--5c351";
export var number = "TimeRemaining-module--number--6876a";